import { httpsCallable } from 'firebase/functions'
import useStore from '../store/useStore'
import { getEffectiveServices } from './firebaseServiceContext'

export const auditBlockedImpersonationAction = async (
  action: string,
  resourceType?: string,
  resourceId?: string,
): Promise<void> => {
  if (useStore.getState().identityStatus !== 'impersonating') return
  const callable = httpsCallable<
    { action: string; resourceType?: string; resourceId?: string },
    { recorded: boolean }
  >(
    getEffectiveServices().functions,
    'auditImpersonationActionCallable',
  )
  await callable({ action, resourceType, resourceId })
}
